(() => {
    const isValidZip = (value) => /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);

    const handleZipCodeSubmit = (e) => {
        e.preventDefault();
        const baseUrl = e.target.form.action;
        const searchParams = new URLSearchParams();

        const inputElement = e.target.form.querySelector('.jscls_see-projects-input');
        const currentZipCode = inputElement.value;
        if (isValidZip(currentZipCode)) {
            searchParams.set('zip_code', currentZipCode);
        }

        const searchActionUrl = `${baseUrl}?${searchParams.toString()}`;
        window.open(searchActionUrl);
    };

    document.addEventListener('DOMContentLoaded', () => {
        const elementsSubmit = document.getElementsByClassName('jscls_see-projects-submit');
        Array.from(elementsSubmit).forEach((element) => {
            element.addEventListener('click', handleZipCodeSubmit);
        });
    }, false);
})();
